<template>
  <a-modal modal-id="add-notes">
    <div slot="title">Add a Note</div>
    <div slot="form">
      <div class="row m-t-sm">
        <label>Message</label>
        <textarea class="form-control" cols="30" rows="5" v-model="noteMessage"></textarea>
      </div>
      <div class="row m-t-sm">
        <label for="file">Files</label>
        <input class="form-control" type="file" id="messageFile" ref="messageFile" multiple />
      </div>
    </div>
    <div slot="footer">
      <button class="btn btn-sm btn-primary pull-right" :disabled="!noteMessage.length" @click="addNote"><i class="fa fa-edit m-r-xs"></i> Add note</button>
    </div>
  </a-modal>
</template>
<script>
import axios from 'axios'
import { eventBus } from '../../../main'

export default {
  props: {
    targetType: { required: true },
    targetId: { type: String, required: true }
  },
  data () {
    return {
      noteMessage: ''
    }
  },
  methods: {
    initData () {
      this.noteMessage = ''
      this.$refs.messageFile.value = null
    },
    async addNote () {
      try {
        const formData = new FormData()
        formData.append('type', 'note')
        formData.append('message', this.noteMessage)
        formData.append('targets', JSON.stringify([{ type: this.targetType, id: this.targetId }]))

        for (var i = 0; i < this.$refs.messageFile.files.length; i++) {
          let file = this.$refs.messageFile.files[i]
          formData.append(`files[${i}]`, file)
        }

        await axios.post('/v2/messages', formData)
        eventBus.$emit('loadNotes')
        this.$toastr.success('Note added', 'Success!')
        $('#add-notes').modal('hide')
        this.initData()
      } catch (error) {
        this.$toastr('Failed to add note', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Helpers/Modal/NotesModal.vue